<template>
  <div class="box">
    <div class="content" :style="{ height: dialogHeight, marginTop: dialogMarginTop }">
      <div class="title">
        <slot name="title">提示</slot>
      </div>
      <div class="main">
        <slot name="main-content"></slot>
      </div>
      <div class="footer">
        <slot name="footer"></slot>
      </div>
    </div>
    <div class="close flex_center">
      <van-icon
        name="cross"
        color="#FFF"
        size="16"
        @click="closeDialog"
      />
    </div>
  </div>
</template>

<script>
import { Icon } from 'vant';
export default {
  components: { 'van-icon': Icon },
  props: {
    dialogType: {
      type: String,
      default: ''
    },
    dialogHeight: {
      type: String,
      default: 'fit-content'
    },
    dialogMarginTop: {
      type: String,
      default: '45%'
    }
  },
  data() {
    return {};
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog', this.dialogType)
    }
  },
}
</script>
<style lang='scss' scoped>
.box {
  position: fixed;
  z-index: 100;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.65);
  .content {
    position: relative;
    margin: auto;
    width: 351px;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    .title {
      text-align: center;
      font-size: 19px;
      font-weight: bolder;
      background-color: #FE4F4A;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
      color: #fff;
      height: 38px;
      line-height: 38px;
    }
    .main {
      padding: 32px 28px;
      p {
        text-align: center;
        line-height: 30px;
      }
    }
    .footer {
      padding-bottom: 40px;
    }
  }
  .close {
    width: 30px;
    height: 30px;
    margin: 18px auto 0;
    background-color: #FE4F4A;
    border-radius: 50%;
  }
}

.dialog-button {
  font-size: 15px;
  padding: 0 22px;
  display: flex;
  justify-content: space-between;
  button:first-child {
    margin-right: 12px;
  }
  button:last-child {
    margin-right: 0px;
  }
  .dialog-blue-button, .dialog-white-button {
    outline: none;
    border: none;
    background-color: transparent;
    background-repeat: no-repeat;
    background-size: 100% auto;
  }
  .dialog-blue-button {
    width: 143.5px;
    height: 42px;
    border-radius: 22px;
    background-color: #FE4F4A;
    color: #ffffff;
    flex: 1;
  }
  .dialog-white-button {
    width: 143.5px;
    height: 42px;
    border-radius: 22px;
    background-color: #5C8CCC;
    color: #fff;
    flex: 1;
  }
}
</style>